import { render, staticRenderFns } from "./ChangeOfStatusDropdown.vue?vue&type=template&id=4504d2c3&scoped=true"
import script from "./ChangeOfStatusDropdown.vue?vue&type=script&lang=js"
export * from "./ChangeOfStatusDropdown.vue?vue&type=script&lang=js"
import style0 from "./ChangeOfStatusDropdown.vue?vue&type=style&index=0&id=4504d2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504d2c3",
  null
  
)

export default component.exports